export const MASTER = "/masters";
export const MASTER_DOC = "/masters/document-list";
export const MASTER_SCHOOL_LIST = "/masters/get-school-list";
export const UPLOAD_DOC = "/auth/register/upload-docs";
export const CUSTOM_DROPDOWN = "/masters/dropdown";